export default __webpack_public_path__ + "static/media/company1.5437a91d.svg";